var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"summary__body-card"},[_c('div',{staticClass:"summary__body-card-icon",class:[ 'service-icon' , _vm.iconName ]}),_c('div',{staticClass:"summary__body-card-name"},[_vm._v(_vm._s(_vm.serviceName))]),_c('div',{staticClass:"summary__body-card-total"},[_vm._v("$ "+_vm._s(_vm.serviceTotal))])])
}
var staticRenderFns = []

export { render, staticRenderFns }